import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { CssBaseline } from 'common/components';
import type { ProductCarouselProps } from 'features/product/product-carousel/types';
import { ProductCarousel } from 'features/product/product-carousel';

export const ProductCarouselWidget: React.FC<ProductCarouselProps> = ({ ...props }) => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <ProductCarousel {...props} />
    </ThemeProvider>
  );
};
